import { render, staticRenderFns } from "./StudentQuizList.vue?vue&type=template&id=367d3b1b&scoped=true&"
import script from "./StudentQuizList.vue?vue&type=script&lang=js&"
export * from "./StudentQuizList.vue?vue&type=script&lang=js&"
import style0 from "./StudentQuizList.vue?vue&type=style&index=0&id=367d3b1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d3b1b",
  null
  
)

export default component.exports